import useCustomFunc from '@/composables/custom-func/custom-func';
import { defaultExclusionCheck } from '@/composables/exclusion-checks';
import { walk } from 'shared/lib/walker/query-walker';

const extractCustomFunctions = (queries) => {
  const customFunctions = [];

  walk(queries, 'children', (node) => {
    if (node.customFunc !== undefined && node.alias !== undefined) {
      customFunctions.push({
        alias: node.alias,
        customFunc: node.customFunc,
      });
    }
  });

  return customFunctions;
};

export function useCustomFuncExclusionCheck() {
  const { hasAllEntriesForEntity } = useCustomFunc();

  const customFuncGoalExclusionCheck = (entity, context) => {
    const { queries } = context;

    const customFunctions = extractCustomFunctions(queries);
    if (customFunctions.length === 0) {
      return true;
    }

    return customFunctions.every((customFunc) => hasAllEntriesForEntity(entity, customFunc.customFunc.name, customFunc.alias, customFunc.customFunc?.args || []));
  };

  return { customFuncGoalExclusionCheck };
}

export function useGoalExclusionCheck() {
  const { customFuncGoalExclusionCheck } = useCustomFuncExclusionCheck();

  const shouldExclude = (entity, context) => [defaultExclusionCheck, customFuncGoalExclusionCheck].every((fn) => fn(entity, context));

  return { shouldExclude };
}
